import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import { getServiceBySlug, serviceCategories } from "./ServicesContent";

export default function OneService(props) {
  const { serviceSlug } = props;
  const appContext = useContext(AppContext);
  const service = getServiceBySlug(serviceSlug) || serviceCategories[0];

  return (
    <>
      <PageHero
        eyebrow="Service"
        title={service.title}
        text={service.summary}
        image={service.heroImage}
      />

      <section className="tgm-section tgm-service-detail" data-aos="fade-up">
        <div className="container">
          <div className="tgm-service-detail-layout">
            <div className="tgm-service-detail-main">
              <p className="tgm-section-kicker">{service.navTitle}</p>
              <h2>Focused support from planning to delivery.</h2>
              <p>{service.intro}</p>

              <div className="tgm-detail-block">
                <h3>Subservices</h3>
                <div className="tgm-pill-grid">
                  {service.subServices.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </div>

              <div className="tgm-detail-block">
                <h3>How SMART TGM Supports This Work</h3>
                <div className="tgm-highlight-grid">
                  {service.highlights.map((item, index) => (
                    <div className="tgm-highlight-card" key={item}>
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <aside className="tgm-service-detail-aside">
              <img src={service.heroImage} alt={service.title} />
              <div>
                <h3>Ready to discuss this service?</h3>
                <p>
                  Share your project scope with our team so we can help clarify
                  the next practical step.
                </p>
                <button
                  type="button"
                  className="tgm-solid-btn"
                  onClick={() => appContext.navTo({ item: "contact_us" })}
                >
                  Contact us <MdArrowForward />
                </button>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
